<div class="light-theme w-[450px] bg-white/70 p-6! gap-6! flex flex-col shadow rounded-lg">
  <a [routerLink]="['/']" class="w-max mx-auto">
    <img src="/assets/images/logos/gfli-light-logo.webp" alt="logo Gfli" class="w-[100px]" />
  </a>
  <app-dynamic-form class="public-auth-form" [formGroup]="resetPasswordForm" [formConfigs]="formConfig" [onSubmit]="onSubmit" [spinLoader]="spinLoader" />
</div>
